import { render, staticRenderFns } from "./CourseDetailModal.vue?vue&type=template&id=f02f6f9c&scoped=true"
import script from "./CourseDetailModal.vue?vue&type=script&lang=js"
export * from "./CourseDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailModal.vue?vue&type=style&index=0&id=f02f6f9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02f6f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f02f6f9c')) {
      api.createRecord('f02f6f9c', component.options)
    } else {
      api.reload('f02f6f9c', component.options)
    }
    module.hot.accept("./CourseDetailModal.vue?vue&type=template&id=f02f6f9c&scoped=true", function () {
      api.rerender('f02f6f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/CourseDetailModal.vue"
export default component.exports